import { render, staticRenderFns } from "./UserMessageBubble.vue?vue&type=template&id=3309eefb&scoped=true&"
import script from "./UserMessageBubble.vue?vue&type=script&lang=js&"
export * from "./UserMessageBubble.vue?vue&type=script&lang=js&"
import style0 from "./UserMessageBubble.vue?vue&type=style&index=0&id=3309eefb&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3309eefb",
  null
  
)

export default component.exports